
<div class="Page404Contain justify-content-center align-items-center">
    <div class="Page404 justify-content-center align-items-center">
        <h1>401</h1>
        <p>You are not authotized for selected action.</p>
        <button class="btn-bd-empty">
            <a routerLink="/dashboard">Home Page</a>
        </button>
    </div>
</div>